import React from 'react';
import './ResumenPreguntas.css';

/**
 * Componente que muestra el resumen de preguntas
 * Con renderizado de HTML para preguntas y opciones
 */
const ResumenPreguntas = ({ 
  preguntas,
  totalPreguntas,
  totalOpciones,
  puntajeTotal,
  onEdit,
  readOnly = false
}) => {
  // Función para limpiar y truncar HTML
  const obtenerTextoPlano = (html, maxLength = 80) => {
    if (!html) return 'Sin título';
    
    // Crear elemento temporal para extraer texto
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const texto = temp.textContent || temp.innerText || '';
    
    return texto.length > maxLength 
      ? texto.substring(0, maxLength) + '...'
      : texto;
  };
  
  return (
    <div className="card mb-4">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h6 className="mb-0">
          <i className="fas fa-question-circle me-2 text-warning"></i>
          Preguntas ({totalPreguntas})
        </h6>
        {!readOnly && (
          <button 
            type="button" 
            className="step4-btn-edit"
            onClick={() => onEdit(3)}
          >
            <i className="fas fa-edit me-1"></i>
            Editar
          </button>
        )}
      </div>
      <div className="card-body">
        {totalPreguntas === 0 ? (
          <div className="text-center py-3">
            <i className="fas fa-question-circle fa-2x text-muted mb-2"></i>
            <p className="text-muted mb-0">No hay preguntas agregadas</p>
            <small className="text-muted">Agregue preguntas para que los usuarios puedan responder</small>
          </div>
        ) : (
          <div>
            {/* Lista de preguntas con HTML renderizado */}
            <div className="preguntas-resumen">
              {preguntas.map((pregunta) => {
                const puntajePregunta = pregunta.opciones?.reduce((suma, opcion) => 
                  suma + (parseFloat(opcion.puntaje) || 0), 0) || 0;
                const opcionesCorrectas = pregunta.opciones?.filter(opt => opt.esCorrecta).length || 0;
                
                return (
                  <div key={pregunta.id} className="pregunta-resumen-card mb-3">
                    <div className="pregunta-header">
                      <div className="d-flex align-items-start">
                        <span className="badge mr-2 mt-1" style={{ marginRight: '10px', fontSize: '0.9rem', fontWeight: '700', backgroundColor: '#1e88e5', color: '#ffffff', padding: '6px 12px', borderRadius: '8px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: '30px' }}>#{pregunta.numero}</span>
                        <div className="flex-grow-1">
                          <div 
                            className="pregunta-texto"
                            dangerouslySetInnerHTML={{ __html: pregunta.pregunta }}
                          />
                          <div className="pregunta-info mt-2">
                            <span className="text-muted small me-2">
                              <i className="fas fa-list-ul me-1"></i>
                              {pregunta.opciones?.length || 0} opciones
                            </span>
                            <span className="text-muted small me-2">
                              <i className="fas fa-check-circle me-1"></i>
                              {opcionesCorrectas} correctas
                            </span>
                            <span className="badge bg-success">
                              <i className="fas fa-star me-1"></i>
                              {puntajePregunta} pts
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Opciones de la pregunta */}
                    {pregunta.opciones && pregunta.opciones.length > 0 && (
                      <div className="opciones-resumen mt-2">
                        {pregunta.opciones.map((opcion, idx) => (
                          <div 
                            key={idx} 
                            className={`opcion-resumen-item ${opcion.esCorrecta ? 'opcion-correcta' : ''}`}
                          >
                            <div className="d-flex align-items-start">
                              <span className={`opcion-letra ${opcion.esCorrecta ? 'letra-correcta' : ''}`}>
                                {String.fromCharCode(65 + idx)}
                              </span>
                              <div 
                                className="opcion-texto flex-grow-1"
                                dangerouslySetInnerHTML={{ __html: opcion.texto }}
                              />
                              <div className="opcion-puntaje">
                                {opcion.puntaje} pts
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResumenPreguntas;
